import React, { useState } from 'react';
import './CustomDropdown.css';


const valueToString  = (option) => {
    if(option === undefined || option === null) return

    if(typeof option === 'object')  {return  option.name ?? ''} else if(typeof  option === 'string'){
        return  option
    }
}

export const CustomDropdown = ({ options, selectedOption, onOptionSelect, placeholder }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleToggle = () => setIsOpen(!isOpen);
    const handleOptionClick = (option) => {
        onOptionSelect(option);
        setIsOpen(false);
    };

    return (
        <div className="custom-dropdown">
            <div className="custom-dropdown-select" onClick={handleToggle}>
                <span>{valueToString(selectedOption) ?? placeholder}</span>
                <svg className={`dropdown-icon ${isOpen ? 'open' : ''}`} width="17" height="11" viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L9 9L16 1" stroke="#595959" strokeWidth="2" strokeLinecap="round" />
                </svg>
            </div>

            {isOpen && (
                <div className="custom-dropdown-options">
                    {options.length === 0 ?    <div
                        className="custom-dropdown-option"
                    >
                        Нет элементов для выбора
                    </div> :
                        <>
                    {options.map((option) => (
                        <div
                            key={option.name ?? option}
                            className="custom-dropdown-option"
                            onClick={() => handleOptionClick(option)}
                        >
                            {valueToString(option)}
                        </div>
                    ))}
                        </>}
                </div>
            )}
        </div>
    );
};